export const ACTIONS = {
  CMTSDATA: 'CMTSDATA',
  CONTENTCARDDATA: 'CONTENTCARDDATA',
  TAGS: 'TAGS',
  CONTENTSETTINGS: 'CONTENTSETTINGS',
  CONTENTTYPES: 'CONTENTTYPES',
  GROUPRADARID: 'GROUPRADARID',
  GETRADARDATAACTION: 'GETRADARDATAACTION',
  DEVPATHS: 'DEVPATHS',
  TAGACTIVATED: 'TAGACTIVATED',
  MAINACTORS: 'MAINACTORS',
  RELATEDSCENARIOS: 'RELATEDSCENARIOS',
  RELATEDSCENARIOSDATA: 'RELATEDSCENARIOSDATA',
  SCENARIOSET: 'SCENARIOSET',
  SCENARIO: 'SCENARIO',
}
